/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';

import Typography from '../../base/Typography';

// using px values on the width to be consistent with svg values
export const BarChartContainer = styled.div`
  width:100%; 
  max-width:500px;
  margin: auto;
`;

export const BarChartTitleTypography = styled(Typography)`
  text-transform:uppercase;
`;

export const BarChartLegend = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    const justifyContentExpression = smallUp
      ? 'center'
      : 'flex-start';
    return css`
      display: flex;
      flex-direction: row;
      justify-content: ${justifyContentExpression};
      margin-top:2rem;
      flex-wrap:wrap;
  `;
  }
}`;

export const BarChartLegendLabel = styled.div`
  ${({ color }) => css`
  display:flex;
  margin-bottom:1rem;
    ::before {
      content: '';
      display: inline-block;
      width: 23px;
      height: 100%;
      background-color: ${color};
      margin:0 1rem;
    }
  `}
`;

export const LegendTypography = styled(Typography)`
  && {
    font-size:1rem;
    padding-bottom:0;
    line-height:1rem;
  }
`;

export const AxisLabelYTypography = styled(Typography)`
  && {
    ${({ theme }) => css`
      font-size: 0.8rem;
      color: ${theme.colors.neutral.grey29};
      font-style:italic;
    `}
  }
`;

export const DisclosureTypography = styled(Typography)`
  && {
    font-size:0.8rem;
    margin-top:2rem;
  }
`;
